import { useCreateDiscipline } from '@/api/hooks';
import * as yup from 'yup';
import { useFormHandler } from '@/hooks/useFormHandler';
import { useToast } from '@/hooks/useToast';
import { useLessons } from '@/pages/Lessons/lessons.hook';
import { useTopicsStore } from '@/store/TopicStore/TopicsStore';
import { DisciplineType } from '@/api/gql/graphql';

const validationSchema = yup.object({
  name: yup.string().required('Champ requis'),
});

export type TopicFormValues = {
  name: string;
};

export const useTopicsList = () => {
  const { showToast } = useToast();
  const { isOpenTopicModal, openTopicModal, selectedDiscipline } =
    useTopicsStore();
  const { mutate: createDiscipline, isPending } = useCreateDiscipline();
  const { loadingData, disciplines } = useLessons();

  const { register, handleSubmit, errors } =
    useFormHandler<TopicFormValues>(validationSchema);

  const addTopics = (values: TopicFormValues) => {
    createDiscipline(
      {
        name: values.name,
        description: `Matière ${values.name}`,
        type: DisciplineType.School,
      },
      {
        onSuccess: () => {
          showToast('Matière ajoutée', 'success', {
            autoClose: 3000,
            position: 'top-right',
          });
          openTopicModal();
        },
        onError: (error) => {
          showToast(error?.message, 'error', {
            autoClose: 3000,
            position: 'top-right',
          });
        },
      },
    );
  };
  
  return {
    register,
    errors,
    handleSubmit,
    addTopics,
    isPending,
    openTopicModal,
    isOpenTopicModal,
    disciplines,
    loadingData,
    selectedDiscipline,
  };
};
